import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex-center py-2 border-b last:border-b-0"
};
const _hoisted_2 = {
  class: "grow mr-4"
};
const _hoisted_3 = {
  class: "inline-block text-white text-xs bg-blue-500 px-2 rounded-xl mr-1"
};
const _hoisted_4 = {
  key: 0,
  class: "inline-flex"
};
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import { app } from "@/di";
import { StaffMemberTransferator } from "@/modules/staff/services/StaffMemberTransferator";
import { Coach } from "@/modules/training/entity";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'StaffMember',
  props: {
    staffMember: null
  },
  emits: ['sacked'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const confirmDialog = ref(null);
    const sack = async staffMember => {
      await confirmDialog.value.confirm();
      await app.get(StaffMemberTransferator).sack(staffMember);
      emit('sacked');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(EntityLink, {
        entity: __props.staffMember
      }, null, 8, ["entity"])]), _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.staffMember.constructor.name) + " ", 1), __props.staffMember instanceof _unref(Coach) ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.staffMember.positionArea), 1)) : _createCommentVNode("", true)]), _createTextVNode(" " + _toDisplayString(_ctx.$moneyPerMonth(__props.staffMember.wage)) + " | " + _toDisplayString(_ctx.$money(__props.staffMember.marketValue)) + " | " + _toDisplayString(_ctx.$money(__props.staffMember.sackPrice)), 1)]), _renderSlot(_ctx.$slots, "action", {}, () => [_createElementVNode("div", null, [_createVNode(_component_NButton, {
        secondary: "",
        size: "small",
        type: "error",
        onClick: _cache[0] || (_cache[0] = $event => sack(__props.staffMember))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.DocumentBulletListOff20Regular
        }, null, 8, ["icon"])]),
        _: 1
      })]), _createVNode(RichDialog, {
        ref_key: "confirmDialog",
        ref: confirmDialog,
        price: __props.staffMember.sackPrice,
        "gate-type": _ctx.GateTypeEnum.BALANCE,
        "gate-value": __props.staffMember.sackPrice
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sure_you_want_to_sack_the_staff_member?')), 1)]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('this_action_is_permanent_and_can_be_reverted')), 1)]),
        _: 1
      }, 8, ["price", "gate-type", "gate-value"])])]);
    };
  }
});